



import React, { useEffect, useState } from "react";
import axios from "axios";
import apiUrl from "../../environment/Api";
import * as XLSX from "xlsx";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useLocation } from "react-router-dom";

function DailyReport() {
  const { pathname } = useLocation();
  const [enquiryData, setEnquiryData] = useState([]);
  const [studentData, setStudentData] = useState([]);
  const [incomeoverall, setincomeoverall] = useState([]);
  const [expenseoverall, setexpenseoverall] = useState([]);
  const [studentreportcount, setstudentreport] = useState([]);
  const [attendancereport, setattendancereport] = useState([]);

  // State for Enquiry
  const [searchTermEnquiry, setSearchTermEnquiry] = useState("");
  const [entriesPerPageEnquiry, setEntriesPerPageEnquiry] = useState(10);
  const [currentPageEnquiry, setCurrentPageEnquiry] = useState(1);

  // code to store the branchlist
  const [branch, setbranch] = useState([])
  const [Branches, setselectBranch] = useState("")


  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant" // or "smooth"
    });
  }, [pathname]);

  // State for Student
  // const [searchTermStudent, setSearchTermStudent] = useState("");
  // const [entriesPerPageStudent, setEntriesPerPageStudent] = useState(10);
  // const [currentPageStudent, setCurrentPageStudent] = useState(1);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [
          enquiryResponse,
          expenseResponse,
          incomeResponse,
          studentResponse,
        ] = await Promise.all([
          // axios.get(`${apiUrl}/leadsreport`),
          // axios.get(`${apiUrl}/expense_listreport`),
          // axios.get(`${apiUrl}/income_listreport`),
          // axios.get(`${apiUrl}/studingstudentreport`),

          axios.get(`${apiUrl}/leads`),
          axios.get(`${apiUrl}/expense_list`),
          axios.get(`${apiUrl}/income_list`),
          axios.get(`${apiUrl}/studingstudentreport`),
        ]);

        setEnquiryData(enquiryResponse.data);

        setExpenseData(expenseResponse.data);
        setIncomeData(incomeResponse.data);
        setStudentData(studentResponse.data);
      } catch (error) {
        console.error("Error fetching report data:", error);
      }
    };

    fetchData();
  }, []);

  // Get today's date in YYYY-MM-DD format
  const today = new Date().toISOString().split("T")[0];
  const [selectedDate, setSelectedDate] = useState(today);
  // const [selectedDate, setSelectedDate] = useState("");

  // Enquiry Filtering and Pagination
  // const filteredEnquiryData = enquiryData.filter(
  //   (item) =>
  //     (item.student_name &&
  //       item.student_name
  //         .toLowerCase()
  //         .includes(searchTermEnquiry.toLowerCase())) ||
  //     (item.Prefered_course &&
  //       item.Prefered_course.toLowerCase().includes(
  //         searchTermEnquiry.toLowerCase()
  //       )) ||
  //     (item.Source_type &&
  //       item.Source_type.toLowerCase().includes(
  //         searchTermEnquiry.toLowerCase()
  //       )) ||
  //     (item.followups_status &&
  //       item.followups_status
  //         .toLowerCase()
  //         .includes(searchTermEnquiry.toLowerCase()))
  // );
  const filteredEnquiryData = enquiryData.filter((item) => {
    const matchesDate = selectedDate
      ? new Date(item.Enquiry_date).toLocaleDateString() ===
      new Date(selectedDate).toLocaleDateString()
      : true;

    const matchesSearchTerm =
      (item.student_name &&
        item.student_name
          .toLowerCase()
          .includes(searchTermEnquiry.toLowerCase())) ||
      (item.Prefered_course &&
        item.Prefered_course.toLowerCase().includes(
          searchTermEnquiry.toLowerCase()
        )) ||
      (item.Source_type &&
        item.Source_type.toLowerCase().includes(
          searchTermEnquiry.toLowerCase()
        )) ||
      (item.followups_status &&
        item.followups_status
          .toLowerCase()
          .includes(searchTermEnquiry.toLowerCase()));


    //code to check branch match
    const isBranchMatch = Branches
      ? item.branch_id.branch_name === Branches
      : true;

    return matchesDate && matchesSearchTerm && isBranchMatch;
  });

  const totalPagesEnquiry = Math.ceil(
    filteredEnquiryData.length / entriesPerPageEnquiry
  );
  const displayedEnquiryData = filteredEnquiryData.slice(
    (currentPageEnquiry - 1) * entriesPerPageEnquiry,
    currentPageEnquiry * entriesPerPageEnquiry
  );


  // Student Filtering and Pagination
  // const filteredStudentData = studentData.filter(
  //   (item) =>
  //     item.name &&
  //     item.name.toLowerCase().includes(searchTermStudent.toLowerCase())
  // );

  // const totalPagesStudent = Math.ceil(
  //   filteredStudentData.length / entriesPerPageStudent
  // );
  // const displayedStudentData = filteredStudentData.slice(
  //   (currentPageStudent - 1) * entriesPerPageStudent,
  //   currentPageStudent * entriesPerPageStudent
  // );

  // Placeholder functions for export actions
  const handleCopy = (tableId) => {
    const tableElement = document.getElementById(tableId);
    if (tableElement) {
      const rows = Array.from(tableElement.rows)
        .map((row) =>
          Array.from(row.cells)
            .map((cell) => cell.innerText)
            .join("\t")
        )
        .join("\n");

      navigator.clipboard
        .writeText(rows)
        .then(() => {
          alert("Table data copied to clipboard!");
        })
        .catch((err) => {
          console.error("Failed to copy text: ", err);
        });
    } else {
      console.error(`Table with ID '${tableId}' not found`);
    }
  };


  // ============= code to format the date ===================================
  const formatDate = (isoDate) => {
    if (!isoDate) return ""; // Return an empty string if no date is provided
    const date = new Date(isoDate);

    const day = date.getDate().toString().padStart(2, "0"); // Add leading zero for single-digit days
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Add leading zero for single-digit months
    const year = date.getFullYear();

    return `${day}-${month}-${year}`; // Format as "day-month-year"
  };

  const formatDate2 = (isoDate) => {
    if (!isoDate) return ""; // Return an empty string if no date is provided
    const date = new Date(isoDate);

    const day = date.getDate().toString().padStart(2, "0"); // Add leading zero for single-digit days
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Add leading zero for single-digit months
    const year = date.getFullYear();

    return `${year}-${month}-${day}`; // Format as "day-month-year"
  };
  // ============= code to format the date ===================================

  const handleExport = (tableId, fileName) => {
    const tableElement = document.getElementById(tableId);
    if (tableElement) {
      const worksheet = XLSX.utils.table_to_sheet(tableElement);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      XLSX.writeFile(workbook, fileName);
    } else {
      console.error(
        `Table with ID '${tableId}' not found. Check if the table is rendered in the DOM.`
      );
    }
  };

  const handleGeneratePDF = (tableId, fileName) => {
    const tableElement = document.getElementById(tableId);
    if (!tableElement) {
      console.error(`Table with ID '${tableId}' not found`);
      return;
    }
    html2canvas(tableElement)
      .then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF();
        pdf.addImage(imgData, "PNG", 10, 10, 190, 0);
        pdf.save(fileName);
      })
      .catch((error) => {
        console.error("Error generating PDF: ", error);
      });
  };

  const handlePrint = (tableId, reportTitle) => {
    const printWindow = window.open("", "_blank");
    const tableElement = document.getElementById(tableId);
    if (tableElement) {
      printWindow.document.write(`
        <html>
          <head>
            <title>${reportTitle}</title>
            <style>
              table { width: 100%; border-collapse: collapse; }
              th, td { border: 1px solid #000; padding: 8px; text-align: left; }
              th { background-color: #f2f2f2; }
            </style>
          </head>
          <body>
            <h1>${reportTitle}</h1>
            <div>${tableElement.outerHTML}</div>
          </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.print();
    } else {
      console.error(`Table with ID '${tableId}' not found`);
    }
  };
  // Attendance Report Start
  const [attendanceData, setAttendanceData] = useState([]);
  const [displayedAttendanceData, setDisplayedAttendanceData] = useState([]);
  const [entriesPerPageAttendance, setEntriesPerPageAttendance] = useState(10);
  const [currentPageAttendance, setCurrentPageAttendance] = useState(1);
  const [searchTermAttendance, setSearchTermAttendance] = useState("");

  // Fetch attendance data from the backend
  // ("http://192.168.1.38:8000/api/attendancereport")

  useEffect(() => {
    axios
      // .get (apiUrl + "/attendancereport")
      .get(apiUrl + "/attendance_overall")
      // .get(apiUrl + "/attendance")
      .then((response) => {
        setAttendanceData(response.data);

        // console.log("The attendance_overall data is : ",response.data);
      })
      .catch((error) => {
        console.error("Error fetching attendance data:", error);
      });
  }, []);

  const filteredAttendanceData = attendanceData.filter((item) => {
    const matchesDate = selectedDate
      ? new Date(item.date).toLocaleDateString() ===
      new Date(selectedDate).toLocaleDateString()
      : true;

    const matchesSearchTerm =
      item.name.toLowerCase().includes(searchTermAttendance.toLowerCase()) ||
      item.empid.toLowerCase().includes(searchTermAttendance.toLowerCase());


    return matchesDate && matchesSearchTerm;
  });

  // Filter data based on the search term
  useEffect(() => {
    // const filteredData = attendanceData.filter((item) =>
    //   item.name.toLowerCase().includes(searchTermAttendance.toLowerCase())
    // );

    const filteredData = attendanceData.filter((item) => {
      // const matchesDate = selectedDate
      //   ? new Date(item.date).toLocaleDateString() ===
      //     new Date(selectedDate).toLocaleDateString()
      //   : true;

      const matchesDate = selectedDate
        ? new Date(item.date).toLocaleDateString() ===
        new Date(selectedDate).toLocaleDateString()
        : true;

      const matchesSearchTerm =
        item.name.toLowerCase().includes(searchTermAttendance.toLowerCase()) ||
        item.empid.toLowerCase().includes(searchTermAttendance.toLowerCase()) ||
        item.branch_id.branch_name.toLowerCase().includes(searchTermAttendance.toLowerCase()) ||
        item.login.toLowerCase().includes(searchTermAttendance.toLowerCase()) ||
        item.logout.toLowerCase().includes(searchTermAttendance.toLowerCase()) ||
        item.workhour.toLowerCase().includes(searchTermAttendance.toLowerCase());

      // // code to matchbranches
      // const isBranchMatch = Branches
      // ? item.branch_id?.branch_name === Branches
      // : true; 
      // const isBranchMatch = Branches
      // ? item.branch_id?.branch_name === Branches
      // : true;

      // return matchesDate && matchesSearchTerm;
      return matchesSearchTerm && matchesDate;
      // return matchesSearchTerm && matchesDate && isBranchMatch;
    });

    const startIdx = (currentPageAttendance - 1) * entriesPerPageAttendance;
    const endIdx = startIdx + entriesPerPageAttendance;
    setDisplayedAttendanceData(filteredData.slice(startIdx, endIdx));
  }, [
    attendanceData,
    searchTermAttendance,
    currentPageAttendance,
    entriesPerPageAttendance,
    selectedDate
  ]);

  const totalPagesAttendance = Math.ceil(
    attendanceData.filter((item) =>
      item.name.toLowerCase().includes(searchTermAttendance.toLowerCase())
    ).length / entriesPerPageAttendance
  );

  const handleEntriesPerPageChange =
    (setEntriesPerPage, setCurrentPage) => (e) => {
      setEntriesPerPage(Number(e.target.value));
      setCurrentPage(1);
    };

  // Attendance Report End

  // Expense Report Start

  // State for Expense
  const [searchTermExpense, setSearchTermExpense] = useState("");
  const [entriesPerPageExpense, setEntriesPerPageExpense] = useState(10);
  const [currentPageExpense, setCurrentPageExpense] = useState(1);
  const [expenseData, setExpenseData] = useState([]);

  // Fetch data
  useEffect(() => {
    const fetchData = async () => {
      try {
        // const expenseResponse = await axios.get(`${apiUrl}/expense_listreport`);
        const expenseResponse = await axios.get(`${apiUrl}/expense_list`);
        setExpenseData(expenseResponse.data);
      } catch (error) {
        console.error("Error fetching expense data:", error);
      }
    };

    fetchData();
  }, []);

  const filteredExpenseData = expenseData.filter((item) => {
    // // Check if the item has notes and if they match the search term
    // const matchesNotes =
    //   item.notes &&
    //   item.notes.toLowerCase().includes(searchTermExpense.toLowerCase());

    // Check if the selected date matches the item's date (if selectedDate exists)
    const matchesDate = selectedDate
      ? new Date(item.date).toLocaleDateString() ===
      new Date(selectedDate).toLocaleDateString()
      : true;

    const matchesSearchTerm =
      item.notes.toLowerCase().includes(searchTermExpense.toLowerCase()) ||
      String(item.amount).toLowerCase().includes(searchTermExpense.toLowerCase()) ||
      item.expense_type.toLowerCase().includes(searchTermExpense.toLowerCase()) ||
      item.paidto.toLowerCase().includes(searchTermExpense.toLowerCase()) ||
      item.paytype.toLowerCase().includes(searchTermExpense.toLowerCase()) ||
      item.branch_id[0].branch_name.toLowerCase().includes(searchTermExpense.toLowerCase()) ||
      item.type[0].type.toLowerCase().includes(searchTermExpense.toLowerCase());

    //code to mathc the selected branch 
    const isBranchMatch = Branches
      ? item.branch_id[0]?.branch_name === Branches
      : true;

    // console.log("the item.branch_id[0]?.branch_name is : ", Branches? "Branch availbale" : "No brnach data");

    // Return the item if both conditions match
    // return matchesNotes && matchesDate;
    return matchesSearchTerm && matchesDate && isBranchMatch;
    // return matchesNotes; 

  });

  const totalPagesExpense = Math.ceil(
    filteredExpenseData.length / entriesPerPageExpense
  );

  const displayedExpenseData = filteredExpenseData.slice(
    (currentPageExpense - 1) * entriesPerPageExpense,
    currentPageExpense * entriesPerPageExpense
  );


  // Expense Report End

  // Income Report Start

  const [incomeData, setIncomeData] = useState([]);
  const [searchTermIncome, setSearchTermIncome] = useState("");
  const [entriesPerPageIncome, setEntriesPerPageIncome] = useState(10);
  const [currentPageIncome, setCurrentPageIncome] = useState(1);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [
          // enquiryResponse,
          // expenseResponse,
          incomeResponse,
          // studentResponse,
        ] = await Promise.all([
          // axios.get(`${apiUrl}/leadsreport`),
          // axios.get(`${apiUrl}/expense_listreport`),
          // axios.get(`${apiUrl}/income_listreport`),
          axios.get(`${apiUrl}/income_list`),
          // axios.get(`${apiUrl}/studingstudentreport`),
        ]);

        // setEnquiryData(enquiryResponse.data);
        // setExpenseData(expenseResponse.data);
        setIncomeData(incomeResponse.data);
        // setStudentData(studentResponse.data);
      } catch (error) {
        console.error("Error fetching report data:", error);
      }
    };

    fetchData();
  }, []);

  // Income Filtering and Pagination
  // const filteredIncomeData = incomeData.filter((item) => {
  //   const branchName = item.branch_id[0]?.branch_name || "";
  //   const typeName = item.type[0]?.type || "";
  //   return (
  //     branchName.toLowerCase().includes(searchTermIncome.toLowerCase()) ||
  //     typeName.toLowerCase().includes(searchTermIncome.toLowerCase()) ||
  //     item.description.toLowerCase().includes(searchTermIncome.toLowerCase())
  //   );
  // });
  const filteredIncomeData = incomeData.filter((item) => {
    // Get the branch name and type name
    const branchName = item.branch_id[0]?.branch_name || "";
    const typeName = item.type[0]?.type || "";

    // Match for the search term in branch name, type name, and description
    const matchesSearchTerm =
      branchName.toLowerCase().includes(searchTermIncome.toLowerCase()) ||
      typeName.toLowerCase().includes(searchTermIncome.toLowerCase()) ||
      item.description.toLowerCase().includes(searchTermIncome.toLowerCase()) ||
      item.type.toLowerCase().includes(searchTermIncome.toLowerCase()) ||
      item.paid_by.toLowerCase().includes(searchTermIncome.toLowerCase()) ||
      item.paid_to.toLowerCase().includes(searchTermIncome.toLowerCase()) ||
      item.paytype.toLowerCase().includes(searchTermIncome.toLowerCase()) ||
      String(item.amount).toLowerCase().includes(searchTermIncome.toLowerCase());

    // Match for the date filter (if selectedDate exists)
    const matchesDate = selectedDate
      ? new Date(item.date).toLocaleDateString() ===
      new Date(selectedDate).toLocaleDateString()
      : true; // If no date is selected, it defaults to true

    // code to match a brnach
    const isBranchMatch = Branches
      ? item.branch_id.branch_name === Branches
      : true;

    // Return the item if it matches both search term and date filter
    return matchesSearchTerm && matchesDate && isBranchMatch;
    // return matchesSearchTerm;
  });

  const totalPagesIncome = Math.ceil(
    filteredIncomeData.length / entriesPerPageIncome
  );
  const displayedIncomeData = filteredIncomeData.slice(
    (currentPageIncome - 1) * entriesPerPageIncome,
    currentPageIncome * entriesPerPageIncome
  );

  // Income Report End

  // Student Report Start



  // ============================ code for csv file download ================================
  const handleEnquiryCSVExport = () => {
    const csvHeaders = [
      "S.No",
      "Name",
      "Mobile No",
      "Course",
      "Source Type",
      "Enquiry Date",
      "Status",
    ];
    const csvData = displayedEnquiryData.map((item, index) => [
      index + 1,
      item.student_name,
      item.mobile_no,
      item.Prefered_course,
      item.Source_type,
      formatDate(item.Enquiry_date),
      item.followups_status,
    ]);

    const csvContent = [
      csvHeaders.join(","), // Headers
      ...csvData.map((row) => row.join(",")), // Data rows
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", "enquiry_report.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // ============================ code for csv file download ================================

  // ============================ code for attendance csv file download =================================

  // code to calculate railway time to normal time
  const railwayToNormalTime = (railwayTime) => {
    if (!railwayTime) return "";
    const [hour, minute] = railwayTime.split(":");
    const parsedHour = parseInt(hour);
    const parsedMinute = parseInt(minute);
    if (parsedHour < 12) {
      return `${parsedHour}:${minute} AM`;
    } else if (parsedHour === 12) {
      return `${parsedHour}:${minute} PM`;
    } else {
      return `${parsedHour - 12}:${minute} PM`;
    }
  };


  const handleAttendanceCSVExport = () => {

    // Define CSV headers
    const csvHeaders = [
      "S.No",
      "Branch Name",
      "Employee ID",
      "Name",
      "Date",
      "Login Time",
      "Logout Time",
      "Work Hours",
      // "Over Time"
    ];

    // Prepare CSV data
    const csvData = displayedAttendanceData.map((item, index) => [
      index + 1, // Serial number
      item.branch_id ? item.branch_id.branch_name : "N/A", // Branch name, with fallback
      item.empid || "N/A", // Employee ID, with fallback
      item.name || "N/A", // Name, with fallback
      // new Date(item.date).toLocaleDateString(), // Format date
      formatDate(item.date), // Format date
      railwayToNormalTime(item.login || ""), // Convert login time
      railwayToNormalTime(item.logout || ""), // Convert logout time
      railwayToNormalTime(item.workhour || ""), // Convert work hours
      // item.overtime || "N/A", // Convert overtime
    ]);

    // Generate CSV content
    const csvContent = [
      csvHeaders.join(","), // Headers
      ...csvData.map((row) => row.join(",")), // Data rows
    ].join("\n");

    // Create a Blob for CSV content and trigger download
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", "attendance_report.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  // ============================ code for attendance csv file download =================================

  //============================= code for expense csv file download ====================================
  const handleexpenseCSVExport = () => {
    const csvHeaders = [
      "S.No",
      "Branch",
      "Type",
      "Date",
      "Notes",
      "Amount",
      "Expense Type",
      "PaidTo",
      "Paytype",
    ];
    const csvData = displayedExpenseData.map((item, index) => [
      index + 1,
      item.branch_id[0]?.branch_name,
      item.type[0]?.type,
      formatDate(item.date),
      item.notes,
      item.amount,
      item.expense_type,
      item.paidto,
      item.paytype,
    ]);

    const csvContent = [
      csvHeaders.join(","), // Headers
      ...csvData.map((row) => row.join(",")), // Data rows
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", "expense_report.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  //============================= code for expense csv file download ====================================

  // ============================ code for income csv file download =====================================
  const handleIncomeCSVExport = () => {
    const csvHeaders = [
      "S.No",
      "Type",
      "Date",
      "Description",
      "Paid by",
      "Paid To",
      "Paytype",
      "Amount",
    ];
    const csvData = displayedIncomeData.map((item, index) => [
      index + 1,
      item.type,
      formatDate(item.date),
      item.description,
      item.paid_by,
      item.paid_to,
      item.paytype,
      item.amount
    ]);

    const csvContent = [
      csvHeaders.join(","), // Headers
      ...csvData.map((row) => row.join(",")), // Data rows
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", "income_report.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // ============================ code for income csv file download =====================================


  const getStatusColor = (status) => {
    switch (status) {
      case "Walkin":
        return "#FFC107"; // Green
      case "Scheduled":
        return "#6c757d"; // Blue
      case "Rescheduled":
        return "#007bff"; // Yellow
      case "NotReachable":
        return "#343a40"; // Gray
      case "New":
        return "#17a2b8"; // Light Blue
      case "Unqualified":
        return "#dc3545"; // Red
      case "Converted":
        return "#28a745";
      case "Phone Ringing":
        return "#F0A04B"; // Black
      default:
        return "bg-light"; // Default Light Gray
    }
  };
  // ========== code to set the color for the label ===================




  const [categoriescount, set_categoriescount] = useState([]);

  useEffect(() => {
    const branchId = localStorage.getItem("branch_id");
    if (branchId == "null") {
      console.log("The local storage branch_id is null : ");

      const fetch_overall_data = async () => {
        try {
          const response = await axios.get(apiUrl + "/leads_count_overall");
          console.log(
            "Response from server with status-count-overall data:",
            response.data
          );

          // set_categoriescount(response.data);

          const receivedData = response.data;

          // Define required categories
          const requiredCategories = [
            "New",
            "Scheduled",
            "Rescheduled",
            "Walkin",
            "Converted",
            "NotReachable",
            "Unqualified",
            "Phone Ringing",
          ];

          // Ensure all categories are present
          const updatedData = requiredCategories.map((status) => {
            const existingCategory = receivedData.find(
              (item) => item.followups_status === status
            );
            return existingCategory || { count: 0, status }; // If not found, add with count 0
          });

          set_categoriescount(updatedData);

          console.log("The updatedData in the useeffect is : ", updatedData);
        } catch (error) {
          console.error("Error fetching data:", error.message);
        }
      };

      fetch_overall_data();
    }
    else {
      const username = localStorage.getItem("username");

      if (username) {
        console.log("The local storage branch_id is null : ");

        const fetch_overall_data = async () => {
          try {
            const response = await axios.get(apiUrl + `/status-count-by-staff/${username}`);
            console.log("Response from server with status-count-overall data:", response.data.statuses);

            // set_categoriescount(response.data);

            const receivedData = response.data.statuses;

            // Define required categories
            const requiredCategories = ["Schedule", "Inprogress", "Completed", "Incompleted"];

            // Ensure all categories are present
            const updatedData = requiredCategories.map((status) => {
              const existingCategory = receivedData.find((item) => item.status === status);
              return existingCategory || { count: 0, status }; // If not found, add with count 0
            });

            set_categoriescount(updatedData);

          } catch (error) {
            console.error("Error fetching data:", error.message);
          }
        }

        fetch_overall_data();
      }
      else {
        alert("Something went wrong!")
      }
    }

    console.log("The useeffect function is called ", branchId == "null");
  }, []);


  // ----------------------------------------------------------------------------------



  const [Categoriescount, set_Categoriescount] = useState([]);


  useEffect(() => {
    // const branchId = localStorage.getItem("branch_id");
    // if (branchd == "null") {
    console.log("The local storage branch_id is null : ");

    const fetch_overall_data = async () => {
      try {
        const response = await axios.get(apiUrl + "/status-count-overall");
        console.log("Response from server with status-count-overall data:", response.data);

        // set_categoriescount(response.data);

        const receivedData = response.data;

        // Define required categories
        const requiredCategories = ["Schedule", "Inprogress", "Completed", "Incompleted"];

        // Ensure all categories are present
        const updatedData = requiredCategories.map((status) => {
          const existingCategory = receivedData.find((item) => item.status === status);
          return existingCategory || { count: 0, status }; // If not found, add with count 0
        });

        set_Categoriescount(updatedData);

      } catch (error) {
        console.error("Error fetching data:", error.message);
      }
    }

    fetch_overall_data();
    // }
    // else {
    //   const username = localStorage.getItem("username");

    //   if (username) {
    //     console.log("The local storage branch_id is null : ");

    //     const fetch_overall_data = async () => {
    //       try {
    //         const response = await axios.get(apiUrl + `/status-count-by-staff/${username}`);
    //         console.log("Response from server with status-count-overall data:", response.data.statuses);

    //         // set_categoriescount(response.data);

    //         const receivedData = response.data.statuses;

    //         // Define required categories
    //         const requiredCategories = ["Schedule", "Inprogress", "Completed", "Incompleted"];

    //         // Ensure all categories are present
    //         const updatedData = requiredCategories.map((status) => {
    //           const existingCategory = receivedData.find((item) => item.status === status);
    //           return existingCategory || { count: 0, status }; // If not found, add with count 0
    //         });

    //         set_categoriescount(updatedData);

    //       } catch (error) {
    //         console.error("Error fetching data:", error.message);
    //       }
    //     }

    //     fetch_overall_data();
    //   }
    //   else {
    //     alert("Something went wrong!")
    //   }
    // }

    // console.log("The useeffect function is called ", branchId == "null");
  }, []);
  const StatusColor = (status) => {
    switch (status) {
      case "Schedule":
        return "#17a2b8"; // Example color
      case "Inprogress":
        return "#ffc107";
      case "Completed":
        return "#28a745";
      case "Incompleted":
        return "red";
      default:
        return "gray"; // Default color
    }
  };


  // ============== code to get the branch list ============================
  useEffect(() => {
    const getbranchlist = async () => {
      const response = await axios.get(apiUrl + "/Branch");
      console.log("the branch data in attendance list is  : ", response.data);
      setbranch(response.data);
    }

    getbranchlist();
  }, []);

  const handleBranchChange = (event) => {
    console.log("the selected branch is : ", event.target.value);
    setselectBranch(event.target.value);
  }
  // ============== code to get the branch list ============================

  // =============== code to get the daily report data ========================

  const [todayexpensedata, settodayexpensedata] = useState([]);

  useEffect(() => {
    const gettodayexpensedata = async () => {
      try {
        const response = await axios.get(apiUrl + "/expense02")
        console.log("The todayexpensedata in the gettodayexpensedata is : ", response.data);
        settodayexpensedata(response.data);
      }
      catch (error) {
        alert("Something went to fetch Today Expense Data")
      }
    }

    gettodayexpensedata();
  }, []);
  // =============== code to get the daily report data ========================

  // ============= code to filter the today expense card data ============================  
  const filtered_todayexpensedata = todayexpensedata.filter((item) => {
    const isBranchMatch = Branches
      ? item.branch_id.branch_name === Branches
      : true;

    const matchesDate = selectedDate
      ? item.expenses.filter((item) => new Date(item.date).toLocaleDateString() == new Date(selectedDate).toLocaleDateString()) : true;

    // // Match for the date filter (if selectedDate exists)
    // const matchesDate = selectedDate
    //   ? new Date(item.date).toLocaleDateString() ===
    //   new Date(selectedDate).toLocaleDateString()
    //   : true; // If no date is selected, it defaults to true

    return isBranchMatch && matchesDate;
  });

  console.log("the filtered_todayexpensedata in the filter function is : ", filtered_todayexpensedata);
  // ============= code to filter the today expense card data ============================



  useEffect(() => {
    fetchData();
    fetchDataexpense();
    studentreport();
    attendance_report();
  }, []);

  const fetchData = async () => {
    try {

      const response = await axios.get(apiUrl + "/incomedata");
      setincomeoverall(response.data);
      console.log("the response data ", response.data)
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };


  const fetchDataexpense = async () => {
    try {

      const response = await axios.get(apiUrl + "/expensedata");
      setexpenseoverall(response.data);
      console.log("the response data ", response.data)
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };


  const studentreport = async () => {
    try {

      const response = await axios.get(apiUrl + "/student_report");
      setstudentreport(response.data);
      console.log("the response data ", response.data)
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };


  const attendance_report = async () => {
    try {

      const response = await axios.get(apiUrl + "/attendance_report");
      setattendancereport(response.data);
      console.log("the response data ", response.data)
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };







  return (
    <>
      <div
        className="card p-2"
        style={{
          marginTop: "-80px",
          boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
        }}
      >
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-6 pt-2 text-left">
            <h6 className="px-2 pt-2" style={{color:"#8f0505"}}>
              <b>Daily Report</b>
            </h6>
          </div>
          <div
            className="col-lg-6 col-md-6 col-sm-6 pt-2  d-flex "
            style={{ display: "flex", justifyContent: "end", }}
          >
            <div>
              <select
                value={Branches} // Ensure this matches the state variable for the selected branch
                // onChange={(e) => setselectBranch(e.target.value)} // Update the state
                onChange={handleBranchChange}
                className="form-control"
                mx-3
              >
                {/* <option value="">Select branch</option> */}
                <option value="">All branches</option>
                {branch.map((branchItem) => (
                  <option key={branchItem._id} value={branchItem.branch_id?.branch_name}>
                    {branchItem.branch_name}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <p className="pt-2">
                <b>Date</b>
              </p>
            </div>
            <input
              style={{ width: "200px", height: "40px" }}
              type="date"
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
              className="form-control mx-2"
            />
          </div>
        </div>





        <div className="col-lg-12 col-md-12 col-sm-12">
          <div className="card p-3 mt-3">
            <div className="row">
              <div className="col-lg-3 p-1">
                <div className="card text-center border-3">
                  <h6 className="bg-secondary text-white py-1">Today Income</h6>
                  <div className="row">
                    <div className="col-lg-4 mt-4">
                      {/* console.log(  "the data was here", {incomeoverall.branch_name}) */}
                      <span>{incomeoverall[0]?.branch_name}</span><br />
                      <span>{incomeoverall[1]?.branch_name}</span><br />
                    </div>
                    <div className="col-lg-4">
                      Cash<br />
                      <span>{incomeoverall[0]?.cash}</span><br />
                      <span>{incomeoverall[1]?.cash}</span>

                    </div>
                    <div className="col-lg-4"> UPI<br />
                      <span>{incomeoverall[0]?.upi}</span><br />
                      <span>{incomeoverall[1]?.upi}</span></div>
                  </div>
                </div>
              </div>



              <div className="col-lg-3 p-1 ">
                <div className="card text-center border-3">
                  <h6 className="bg-secondary text-white py-1">Today Expense </h6>

                  <div className="row">
                    <div className="col-lg-4 mt-4">
                      {/* console.log(  "the data was here", {incomeoverall.branch_name}) */}
                      <span>{expenseoverall[0]?.branch_name}</span><br />
                      <span>{expenseoverall[1]?.branch_name}</span><br />
                    </div>
                    <div className="col-lg-4">
                      Cash<br />
                      <span>{expenseoverall[0]?.cash}</span><br />
                      <span>{expenseoverall[1]?.cash}</span>

                    </div>
                    <div className="col-lg-4"> UPI<br />
                      <span>{expenseoverall[0]?.upi}</span><br />
                      <span>{expenseoverall[1]?.upi}</span></div>
                  </div>


                </div>
              </div>
              <div className="col-lg-4 p-1">
                <div className="card text-center border-3">
                  <h6 className="bg-secondary text-white py-1">Attendance</h6>
                  <div className="row">
                    <div className="col-lg-3 mt-4">
                      <span>{attendancereport[0]?.branch_name}</span><br />
                      <span>{attendancereport[1]?.branch_name}</span><br />
                    </div>
                    <div className="col-lg-3">
                      Present<br />
                      <div className="col-lg-3 ">
                        <span>{attendancereport[0]?.Present}</span><br />
                        <span>{attendancereport[1]?.Present}</span><br />
                      </div>
                    </div>
                    <div className="col-lg-3">Absent
                      <br />
                      <div className="col-lg-3 ">
                        <span>{attendancereport[0]?.Absent}</span><br />
                        <span>{attendancereport[1]?.Absent}</span><br />
                      </div>
                    </div>
                    <div className="col-lg-3">Weekoff
                      <br />
                      <div className="col-lg-3 ">
                        <span>{attendancereport[0]?.Weekoff}</span><br />
                        <span>{attendancereport[1]?.Weekoff}</span><br />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-2 p-1">
                <div className="card text-center border-3">
                  <h6 className="bg-secondary text-white py-1">Student</h6>
                  <div className="row">
                    <div className="col-lg-6">
                      Present<br />
                      <span>{studentreportcount.presentCount}</span>
                    </div>
                    <div className="col-lg-6">
                      Absent:<br />
                      <span>{studentreportcount.absentCount}</span>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>





      {/* the enquiry */}

      <div className="" style={{ marginTop: '20px' }}> <h6 className="text-center">
        <b>Enquiry</b>
      </h6></div>
      <div
        className="card p-2"
        style={{
          // marginTop: "-80px",
          boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
          marginBottom: "10px"
        }}
      >
        <div className="row">
          {categoriescount.map((item, index) => (
            <div key={index} className="col-lg-3 col-md-6 col-sm-12">
              <div className="card text-center border-3" style={{ marginBottom: "10px" }}>

                <h6 className="text-white py-1" style={{ backgroundColor: getStatusColor(item.followups_status), color: "white" }}>{item.followups_status}</h6>
                <h3 className="">{item.count}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>


      <div style={{ marginTop: '20px' }}> <h6 className="text-center">
        <b>Daily Task </b>
      </h6></div>
      <div
        className="card p-2"
        style={{
          // marginTop: "-80px",
          boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
          marginBottom: "10px"
        }}
      >
        <div className="row">
          {Categoriescount.map((item, index) => (
            <div key={index} className="col-lg-3 col-md-6 col-sm-12">
              <div className="card text-center border-3">

                <h6 className="text-white py-1" style={{ backgroundColor: StatusColor(item.status), color: "white" }}>{item.status}</h6>
                <h3 className="">{item.count}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>


      <div className="container mt-5 bg-white">
        {/* Enquiry Report */}

        <div className="">
          <h6 className="text-center">
            <b>Enquiry Report</b>
          </h6>
          <div className="card-body p-3" style={{ backgroundColor: "#E8EFF9" }}>
            <div className="row">
              <div className="col-md-3 d-flex align-items-center">
                <p className="mb-0 mr-2">Show:</p>
                <select
                  value={entriesPerPageEnquiry}
                  onChange={handleEntriesPerPageChange(
                    setEntriesPerPageEnquiry,
                    setCurrentPageEnquiry
                  )}
                  className="form-control mx-2"
                  style={{ width: "80px" }}
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={filteredEnquiryData.length}>All</option>
                </select>
              </div>

              <div className="col-md-6 text-center">
                <button
                  className="btn btn-secondary2 mx-2"
                  onClick={() => handleCopy("enquiryTable")}
                >
                  Copy
                </button>
                <button
                  className="btn btn-success2 mx-2"
                  // onClick={handleCSVExport1} handleEnquiryCSVExport
                  onClick={() => handleEnquiryCSVExport()}
                >
                  CSV
                </button>
                <button
                  className="btn btn-excel2 mx-2"
                  onClick={() =>
                    handleExport("enquiryTable", "Enquiry_Data.xlsx")
                  }
                >
                  Excel
                </button>
                <button
                  className="btn btn-info2 mx-2"
                  onClick={() =>
                    handleGeneratePDF("enquiryTable", "Enquiry_Report.pdf")
                  }
                >
                  PDF
                </button>
                <button
                  className="btn btn-warning2 mx-2"
                  onClick={() => handlePrint("enquiryTable", "Enquiry Report")}
                >
                  Print
                </button>
              </div>

              <div className="col-md-3 d-flex align-items-center">
                <input
                  type="text"
                  placeholder="Search"
                  value={searchTermEnquiry}
                  onChange={(e) => setSearchTermEnquiry(e.target.value)}
                  className="form-control"
                />
              </div>
            </div>

            <div className="row p-2">
              <div style={{ overflowX: "auto" }}>
                <table className="table table-border" id="enquiryTable">
                  <thead>
                    <tr>
                      <th>S.NO</th>
                      <th>Name</th>
                      <th>Mobile No</th>
                      <th>Course</th>
                      <th>Source Type</th>
                      <th>Enquiry Date</th>

                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {displayedEnquiryData.map((item, index) => (
                      <tr key={item.id}>
                        <td>
                          {index +
                            1 +
                            (currentPageEnquiry - 1) * entriesPerPageEnquiry}
                        </td>
                        <td>{item.student_name}</td>
                        <td>{item.mobile_no}</td>
                        <td>{item.Prefered_course}</td>
                        <td>{item.Source_type}</td>
                        {/* <td>
                          {new Date(item.Enquiry_date).toLocaleDateString()}
                        </td> */}
                        <td>{formatDate(item.Enquiry_date)}</td>

                        <td>{item.followups_status}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {totalPagesEnquiry > 1 && (
              <div className="row">
                <div className="col-lg-10 "></div>
                <div className="col-lg-2 mt-3 pb-5">
                  <nav aria-label="Page navigation">
                    <ul className="pagination justify-content-center">
                      <li
                        className={`page-item ${currentPageEnquiry === 1 ? "disabled" : ""
                          }`}
                      >
                        <button
                          className="page-link"
                          onClick={() =>
                            setCurrentPageEnquiry(currentPageEnquiry - 1)
                          }
                        >
                          Previous
                        </button>
                      </li>
                      {[...Array(totalPagesEnquiry)].map((_, i) => (
                        <li
                          key={i}
                          className={`page-item ${currentPageEnquiry === i + 1 ? "active" : ""
                            }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => setCurrentPageEnquiry(i + 1)}
                          >
                            {i + 1}
                          </button>
                        </li>
                      ))}
                      <li
                        className={`page-item ${currentPageEnquiry === totalPagesEnquiry
                          ? "disabled"
                          : ""
                          }`}
                      >
                        <button
                          className="page-link"
                          onClick={() =>
                            setCurrentPageEnquiry(currentPageEnquiry + 1)
                          }
                        >
                          Next
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Repeat similar structure for Expense Report */}
        <div className="mt-5">
          <h6 className="text-center">
            <b>Attendance Report</b>
          </h6>
          <div className="card-body p-3" style={{ backgroundColor: "#E8EFF9" }}>
            <div className="row">
              <div className="col-md-3 d-flex align-items-center">
                <p className="mb-0 mr-2">Show:</p>
                <select
                  value={entriesPerPageAttendance}
                  onChange={handleEntriesPerPageChange(
                    setEntriesPerPageAttendance,
                    setCurrentPageAttendance
                  )}
                  className="form-control mx-2"
                  style={{ width: "80px" }}
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={attendanceData.length}>All</option>
                </select>
              </div>

              <div className="col-md-6 text-center">
                <button
                  className="btn btn-secondary2 mx-2"
                  onClick={() => handleCopy("attendanceTable")}
                >
                  Copy
                </button>
                <button
                  className="btn btn-success2 mx-2"
                  // onClick={handleCSVExport1} 
                  onClick={() => handleAttendanceCSVExport()}
                >
                  CSV
                </button>
                <button
                  className="btn btn-excel2 mx-2"
                  onClick={() =>
                    handleExport("attendanceTable", "Attendance_Data.xlsx")
                  }
                >
                  Excel
                </button>
                <button
                  className="btn btn-info2 mx-2"
                  onClick={() =>
                    handleGeneratePDF(
                      "attendanceTable",
                      "Attendance_Report.pdf"
                    )
                  }
                >
                  PDF
                </button>
                <button
                  className="btn btn-warning2 mx-2"
                  onClick={() =>
                    handlePrint("attendanceTable", "Attendance Report")
                  }
                >
                  Print
                </button>
              </div>

              <div className="col-md-3 d-flex align-items-center">
                <input
                  type="text"
                  placeholder="Search"
                  value={searchTermAttendance}
                  onChange={(e) => setSearchTermAttendance(e.target.value)}
                  className="form-control"
                />
              </div>
            </div>

            <div className="row p-2">
              <div style={{ overflowX: "auto" }}>
                <table className="table table-border" id="attendanceTable">
                  <thead>
                    <tr>
                      <th>S.NO</th>
                      <th>Branch</th>
                      <th>Employee ID</th>
                      <th>Name</th>
                      <th>Date</th>
                      <th>Login</th>
                      <th>Logout</th>
                      <th>Work Hours</th>
                    </tr>
                  </thead>

                  <tbody>
                    {displayedAttendanceData.map((item, index) => (
                      // {filteredAttendanceData.map((item, index) => (
                      <tr key={item._id}>
                        <td>
                          {index +
                            1 +
                            (currentPageAttendance - 1) *
                            entriesPerPageAttendance}
                        </td>
                        <td>{item.branch_id?.branch_name || "N/A"}</td>
                        <td>{item.empid || "N/A"}</td>
                        <td>{item.name}</td>
                        {/* <td>{new Date(item.date).toLocaleDateString()}</td> */}
                        <td>{formatDate(item.date)}</td>
                        <td>{item.login}</td>
                        <td>{item.logout}</td>
                        <td>{item.workhour}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* {totalPagesAttendance > 1 && (
              <div className="mt-3 pb-5">
                <nav aria-label="Page navigation">
                  <ul className="pagination justify-content-center">
                    <li
                      className={`page-item ${currentPageAttendance === 1 ? "disabled" : ""
                        }`}
                    >
                      <button
                        className="page-link"
                        onClick={() =>
                          setCurrentPageAttendance(currentPageAttendance - 1)
                        }
                      >
                        Previous
                      </button>
                    </li>
                    {[...Array(totalPagesAttendance)].map((_, i) => (
                      <li
                        key={i}
                        className={`page-item ${currentPageAttendance === i + 1 ? "active" : ""
                          }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => setCurrentPageAttendance(i + 1)}
                        >
                          {i + 1}
                        </button>
                      </li>
                    ))}
                    <li
                      className={`page-item ${currentPageAttendance === totalPagesAttendance
                        ? "disabled"
                        : ""
                        }`}
                    >
                      <button
                        className="page-link"
                        onClick={() =>
                          setCurrentPageAttendance(currentPageAttendance + 1)
                        }
                      >
                        Next
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            )} */}
          </div>
        </div>

        {/* Repeat similar structure for Expense Report */}
        <div className="mt-5">
          <h6 className="text-center">
            <b>Expense Report</b>
          </h6>
          <div className="card-body p-3" style={{ backgroundColor: "#E8EFF9" }}>
            <div className="row">
              <div className="col-md-3 d-flex align-items-center">
                <p className="mb-0 mr-2">Show:</p>
                <select
                  value={entriesPerPageExpense}
                  onChange={(e) => {
                    setEntriesPerPageExpense(Number(e.target.value));
                    setCurrentPageExpense(1); // Reset to page 1
                  }}
                  className="form-control mx-2"
                  style={{ width: "80px" }}
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={filteredExpenseData.length}>All</option>
                </select>
              </div>

              {/* <div className="col-md-6 text-center"> */}
              <div className="col-md-6 text-center">
                <button
                  className="btn btn-secondary2 mx-2"
                  onClick={() => handleCopy("expenseTable")}
                >
                  Copy
                </button>
                <button
                  className="btn btn-success2 mx-2"
                  // onClick={handleCSVExport1}
                  onClick={() => handleexpenseCSVExport()}
                >
                  CSV
                </button>
                <button
                  className="btn btn-excel2 mx-2"
                  onClick={() =>
                    handleExport("expenseTable", "Expense_Data.xlsx")
                  }
                >
                  Excel
                </button>
                <button
                  className="btn btn-info2 mx-2"
                  onClick={() =>
                    handleGeneratePDF("expenseTable", "Expense_Report.pdf")
                  }
                >
                  PDF
                </button>
                <button
                  className="btn btn-warning2 mx-2"
                  onClick={() => handlePrint("expenseTable", "Expense Report")}
                >
                  Print
                </button>
              </div>
              {/* </div> */}

              <div className="col-md-3 d-flex align-items-center">
                <input
                  type="text"
                  placeholder="Search"
                  value={searchTermExpense}
                  onChange={(e) => setSearchTermExpense(e.target.value)}
                  className="form-control"
                />
              </div>
            </div>

            <div className="row p-2">
              <div style={{ overflowX: "auto" }}>
                {/* <table className="table table-border" id="incomeTable"> */}
                <table className="table table-border" id="expenseTable">
                  <thead>
                    <tr>
                      <th>S.NO</th>
                      <th>Branch</th>
                      <th>Type</th>
                      <th>Date</th>
                      <th>Notes</th>
                      <th>Amount</th>
                      <th>Expense Type</th>
                      <th>PaidTo</th>
                      <th>Paytype</th>
                    </tr>
                  </thead>

                  <tbody>
                    {displayedExpenseData.map((item, index) => (
                      <tr key={item._id}>
                        <td>
                          {index +
                            1 +
                            (currentPageExpense - 1) * entriesPerPageExpense}
                        </td>
                        <td>{item.branch_id[0]?.branch_name || "N/A"}</td>
                        <td>{item.type[0]?.type || "N/A"}</td>
                        {/* <td>{new Date(item.date).toLocaleDateString()}</td> */}
                        <td>{formatDate(item.date)}</td>
                        <td>{item.notes}</td>
                        <td>{item.amount}</td>
                        <td>{item.expense_type}</td>
                        <td>{item.paidto}</td>
                        <td>{item.paytype}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-9"></div>
              <div className="col-lg-3">
                {totalPagesExpense > 1 && (
                  <div className="mt-3 pb-5">
                    <nav aria-label="Page navigation">
                      <ul className="pagination justify-content-center">
                        <li
                          className={`page-item ${currentPageExpense === 1 ? "disabled" : ""
                            }`}
                        >
                          <button
                            className="page-link"
                            onClick={() =>
                              setCurrentPageExpense(currentPageExpense - 1)
                            }
                          >
                            Previous
                          </button>
                        </li>
                        {[...Array(totalPagesExpense)].map((_, i) => (
                          <li
                            key={i}
                            className={`page-item ${currentPageExpense === i + 1 ? "active" : ""
                              }`}
                          >
                            <button
                              className="page-link"
                              onClick={() => setCurrentPageExpense(i + 1)}
                            >
                              {i + 1}
                            </button>
                          </li>
                        ))}
                        <li
                          className={`page-item ${currentPageExpense === totalPagesExpense
                            ? "disabled"
                            : ""
                            }`}
                        >
                          <button
                            className="page-link"
                            onClick={() =>
                              setCurrentPageExpense(currentPageExpense + 1)
                            }
                          >
                            Next
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Repeat similar structure for Income Report */}
        <div className="mt-5">
          <h6 className="text-center">
            <b>Income Report</b>
          </h6>
          <div className="card-body p-3" style={{ backgroundColor: "#E8EFF9" }}>
            <div className="row">
              <div className="col-md-3 d-flex align-items-center">
                <p className="mb-0 mr-2">Show:</p>
                <select
                  value={entriesPerPageIncome}
                  onChange={(e) => {
                    const value = parseInt(e.target.value, 10);
                    setEntriesPerPageIncome(value);
                    setCurrentPageIncome(1); // Reset to the first page
                  }}
                  className="form-control mx-2"
                  style={{ width: "80px" }}
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={filteredIncomeData.length}>All</option>
                </select>
              </div>

              <div className="col-md-6 text-center">
                <button
                  className="btn btn-secondary2 mx-2"
                  onClick={() => handleCopy("incomeTable")}
                >
                  Copy
                </button>
                <button
                  className="btn btn-success2 mx-2"
                  // onClick={handleCSVExport1}
                  onClick={() => handleIncomeCSVExport()}
                >
                  CSV
                </button>
                <button
                  className="btn btn-excel2 mx-2"
                  onClick={() =>
                    handleExport("incomeTable", "Income_Data.xlsx")
                  }
                >
                  Excel
                </button>
                <button
                  className="btn btn-info2 mx-2"
                  onClick={() =>
                    handleGeneratePDF("incomeTable", "Income_Report.pdf")
                  }
                >
                  PDF
                </button>
                <button
                  className="btn btn-warning2 mx-2"
                  onClick={() => handlePrint("incomeTable", "Income Report")}
                >
                  Print
                </button>
              </div>

              <div className="col-md-3 d-flex align-items-center">
                <input
                  type="text"
                  placeholder="Search"
                  value={searchTermIncome}
                  onChange={(e) => setSearchTermIncome(e.target.value)}
                  className="form-control"
                />
              </div>
            </div>

            <div className="row p-2">
              <div style={{ overflowX: "auto" }}>
                <table className="table table-border" id="incomeTable">
                  <thead>
                    <tr>
                      <th>S.NO</th>
                      {/* <th>Branch Id</th> */}
                      <th>Type</th>
                      <th>Date</th>
                      <th>Description</th>
                      <th>Paid by</th>
                      <th>Paid To</th>
                      <th>Paytype</th>
                      <th>Amount</th>
                    </tr>
                  </thead>

                  <tbody>
                    {displayedIncomeData.length > 0 ? (
                      displayedIncomeData.map((item, index) => (
                        <tr key={item._id}>
                          <td>
                            {index +
                              1 +
                              (currentPageIncome - 1) * entriesPerPageIncome}
                          </td>
                          {/* <td>{item.branch_id || "N/A"}</td> */}
                          <td>{item.type}</td>
                          {/* <td>{new Date(item.date).toLocaleDateString()}</td> */}
                          <td>{formatDate(item.date)}</td>
                          <td>{item.description}</td>
                          <td>{item.paid_by}</td>
                          <td>{item.paid_to}</td>
                          <td>{item.paytype}</td>
                          <td>{item.amount}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="9" className="text-center">
                          No data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-9"></div>
              <div className="col-lg-3">
                {totalPagesIncome > 1 && (
                  <div className="mt-3 pb-5">
                    <nav aria-label="Page navigation">
                      <ul className="pagination justify-content-center">
                        <li
                          className={`page-item ${currentPageIncome === 1 ? "disabled" : ""
                            }`}
                        >
                          <button
                            className="page-link"
                            onClick={() =>
                              setCurrentPageIncome(currentPageIncome - 1)
                            }
                          >
                            Previous
                          </button>
                        </li>
                        {[...Array(totalPagesIncome)].map((_, i) => (
                          <li
                            key={i}
                            className={`page-item ${currentPageIncome === i + 1 ? "active" : ""
                              }`}
                          >
                            <button
                              className="page-link"
                              onClick={() => setCurrentPageIncome(i + 1)}
                            >
                              {i + 1}
                            </button>
                          </li>
                        ))}
                        <li
                          className={`page-item ${currentPageIncome === totalPagesIncome
                            ? "disabled"
                            : ""
                            }`}
                        >
                          <button
                            className="page-link"
                            onClick={() =>
                              setCurrentPageIncome(currentPageIncome + 1)
                            }
                          >
                            Next
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>


      </div>
    </>
  );
}

export default DailyReport;
